// import { createReducer } from "utils/reduxsauce";
import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState(
    "cees",
    {
      metadata: undefined,
      selectedCees: undefined,
      openDialog: false,
      openDeleteDialog: false,
    },
    []
  ),
};

const ceeCreatedSuccess = (state, draft, payload) => {
  const cees = state.cees || [];
  draft.cees = [...cees, payload];

  draft.openDialog = false;
};

const ceeDeleteSuccess = (state, draft, payload) => {
  const cees = state.cees || [];
  draft.cees = cees.filter((a) => a.id != payload.id);
  draft.openDeleteDialog = false;
};

const ceeEditedSuccess = (state, draft, payload) => {
  const cees = state.cees || [];
  var supervisorIndex = cees.findIndex((u) => u.id === payload.id);
  draft.cees[supervisorIndex] = payload;
  draft.openDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};
const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
  draft.cees_errors = [];
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "deleteCee",
    stateName: "cee",
    async: true,
    isPaginated: false,
    successCb: ceeDeleteSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "setCee",
    stateName: "cee",
    async: false,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),

  ...bindReducers(ActionTypes, {
    action: "getAllCee",
    stateName: "cees",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getAllCeeTasks",
    stateName: "ceeTasks",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getAllCeeSpots",
    stateName: "ceeSpots",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getAllMeets",
    stateName: "meets",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getCee",
    stateName: "cee",
    async: true,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "addCee",
    stateName: "cee",
    async: true,
    isPaginated: false,
    successCb: ceeCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editCee",
    stateName: "cee",
    async: true,
    isPaginated: false,
    successCb: ceeEditedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: true,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: true,
    successCb: resetDialog,
  }),
});
